import Trans from 'next-translate/Trans'
import React, { useState } from 'react'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import GHref from 'tennders-market/common/components/element/GHref'
import DOMPurify from 'dompurify'
import dynamic from 'next/dynamic'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowsAltH } from '@fortawesome/free-solid-svg-icons'
import OfferGroups from '../../../market/offer/views/negotation/OfferGroups'
import TruckOffer from './TruckOffer'

const EllipsisToolTip = dynamic(() => import('ellipsis-tooltip-react-chan'), { ssr: false })

const SingleMatchTruck = ({ toMatch, onRefresh }) => {
  const { transaction } = useTransaction()
  const [offering, setoffering] = useState(false)
  const [assigning, setassigning] = useState(false)

  const item = toMatch?.matchedTruck

  return (
    <tr>
      <td>
        <table className={`tennders-table-zebra border-b ${toMatch?.isMarketPlaced ? 'bg-color-s-op15' : null}`}>
          <tbody>
            <tr>
              <td>
                <h4 className="bold mb-0">
                  {item?.company?.name}
                </h4>
                <div className="text-12 conform-email">
                  <EllipsisToolTip options={{ className: 'custom-color-tooltip' }}>{item?.company?.email}</EllipsisToolTip>
                </div>
              </td>
              <td className="text-right">
                {assigning && (
                  <GHref
                    onClick={() => setassigning(false)}
                    className="btn-border standard-btn mr-8"
                  >
                    <Trans i18nKey="offer:cancel" />
                  </GHref>
                )}
                {toMatch?.isUnderNegotiation
                  ? (
                    <GHref className="btn-border standard-btn tennders-truck-first-offer-btn disabled">
                      <Trans i18nKey={`variables:${toMatch?.status?.label}`} />
                    </GHref>
                  )
                  : (
                    <GHref
                      onClick={() => setoffering(!offering)}
                      className="btn-border standard-btn"
                    >
                      {offering ? <Trans i18nKey="offer:cancel" />
                        : (
                          <Trans i18nKey="offer:makeOffer" />
                        )}
                    </GHref>
                  )}

              </td>
            </tr>

            <tr>
              <td colSpan="2">
                <table className="tennders-table-zebra text-center text-12">
                  <tbody>
                    <tr>
                      <td>
                        <strong>{toMatch?.pickupRoute?.label}</strong>
                        {' '}
                        <br />
                        <div className="text-mid-hray">
                          {toMatch?.pickupRoute?.date?.f}
                        </div>
                      </td>
                      <td>
                        <FontAwesomeIcon icon={faArrowsAltH} fontSize={24} className="text-mid-gray" aria-hidden="true" />
                      </td>
                      <td>
                        <div className="text-mid-hray">
                          {toMatch?.deliveryRoute?.label || 'Not defined'}
                        </div>
                      </td>
                      <td className="text-left border-l pl-24">
                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item?.detailedInfo) }} />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            {offering && transaction?.matchedLoad && toMatch?.isUnderNegotiation && (
              <tr>
                <td colSpan={2}>
                  <OfferGroups transaction={toMatch} />
                </td>
              </tr>
            )}
            {offering && transaction?.matchedLoad && !toMatch?.isUnderNegotiation && (
              <TruckOffer
                onRefresh={onRefresh}
                loadTransaction={transaction}
                truckTransaction={toMatch}
              />
            )}
          </tbody>
        </table>
      </td>
    </tr>
  )
}

export default SingleMatchTruck
